<template>
  <div class="object-page-wrapper">
    <div class="page-content">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Фото объекта</h1>
        <div @click="$router.go(-1)" class="go-back-icon">
          <svg
            class="d-block ml-auto"
            xmlns="http://www.w3.org/2000/svg"
            width="17.999"
            height="18"
            viewBox="0 0 17.999 18"
          >
            <path
              id="Union_9"
              data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)"
              fill="#fefefc"
            />
          </svg>
        </div>
      </div>

      <div class="object-photo-gallery">
        <div id="grid-gallery" class="grid-gallery object-photo-gallery">
          <section class="grid-wrap">
            <ul class="grid flex-container f-between f-wrap">
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-2.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-1.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-3.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-4.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-1.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
              <li class="gallery-items flex-half pointer">
                <div class="news-item-img ratio2by1 p-relative hidden">
                  <img
                    src="img/object-img-2.jpg"
                    alt="News Img"
                    class="d-block p-absolute w-100 h-100 transition"
                  />
                </div>
              </li>
            </ul>
          </section>
          <section class="slideshow p-fixed w-100 h-100">
            <ul class="w-100 h-100">
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-1.jpg" alt="img01" class="d-block img-cover" />
                </figure>
              </li>
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-2.jpg" alt="img02" class="d-block img-cover" />
                </figure>
              </li>
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-3.jpg" alt="img03" class="d-block img-cover" />
                </figure>
              </li>
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-4.jpg" alt="img04" class="d-block img-cover" />
                </figure>
              </li>
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-1.jpg" alt="img05" class="d-block img-cover" />
                </figure>
              </li>
              <li>
                <figure class="w-100 h-100 hidden m-0">
                  <img src="img/object-img-2.jpg" alt="img06" class="d-block img-cover" />
                </figure>
              </li>
            </ul>
            <nav>
              <span class="icon nav-prev p-fixed text-center pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <g id="_00" data-name="00" transform="translate(18) rotate(90)">
                    <g id="arrow-back">
                      <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M18,10.125H4.275l6.3,6.3L9,18,0,9,9,0l1.575,1.575-6.3,6.3H18Z"
                        fill="#ca9760"
                      />
                    </g>
                  </g>
                </svg>
              </span>
              <span class="icon nav-next p-fixed text-center pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <g id="_00" data-name="00" transform="translate(18) rotate(90)">
                    <g id="arrow-back">
                      <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M18,10.125H4.275l6.3,6.3L9,18,0,9,9,0l1.575,1.575-6.3,6.3H18Z"
                        fill="#ca9760"
                      />
                    </g>
                  </g>
                </svg>
              </span>
              <span class="icon nav-close p-fixed text-center pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.999"
                  height="18"
                  viewBox="0 0 17.999 18"
                >
                  <path
                    id="Union_9"
                    data-name="Union 9"
                    d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
                    transform="translate(10510 7379)"
                    fill="#ca9760"
                  />
                </svg>
              </span>
            </nav>
            <div class="gallery-counter">
              <div class="gallery-counter__items count-start"></div>
              <div class="counter-separator color-primary mx-1">/</div>
              <div class="gallery-counter__items count-length"></div>
            </div>
            <div class="info-keys icon p-fixed text-uppercase text-center text-white">
              <div class="info-keys-items info-keys__left child-center p-absolute">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <g id="_00" data-name="00" transform="translate(18) rotate(90)">
                    <g id="arrow-back">
                      <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M18,10.125H4.275l6.3,6.3L9,18,0,9,9,0l1.575,1.575-6.3,6.3H18Z"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="info-keys-items info-keys__right child-center p-absolute">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <g id="_00" data-name="00" transform="translate(18) rotate(90)">
                    <g id="arrow-back">
                      <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M18,10.125H4.275l6.3,6.3L9,18,0,9,9,0l1.575,1.575-6.3,6.3H18Z"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </svg>
              </div>Навигация с помощью клавиш со стрелками
            </div>
          </section>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation";
import { CBPGridGallery } from "@/utils";
export default {
  data() {
    return {};
  },
  components: {
    BottomNavigation
  },
  mounted() {
    new CBPGridGallery(document.getElementById("grid-gallery"));
  }
};
</script>

<style></style>
